import { Injectable } from '@angular/core';
import { AbstractOrganizationService } from './abstractOrganizationService';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';
import { getPageParams, PageRequest, SpringPage } from '@shared/page';
import { addHttpParams } from '@shared/utils/request-utils';
import { UserRole } from './admin-user.service';

export type UserQuery = {
  filter?: string;
  role?: UserRole;
};
@Injectable({
  providedIn: 'root',
})
export class OrganizationUserService extends AbstractOrganizationService {
  constructor(
    protected readonly http: HttpClient,
    auth: AuthService,
  ) {
    super(auth);
  }

  public getUsers(userQuery: UserQuery, pageRequest: PageRequest): Observable<SpringPage<OrganizationMember>> {
    return this.http.get<SpringPage<OrganizationMember>>(this.url('/users'), {
      params: addHttpParams(userQuery, getPageParams(pageRequest)),
    });
  }
  public countUsersWithApiKeyAndMfaNone(): Observable<{value: number}> {
    return this.http.get<{value: number}>(this.url('/users/count-with-api-key-and-mfa-none'));
  }

  public setUserRole(email: string, role: UserRole) {
    return this.http.put(this.url(`/users/${email}`), { role });
  }

  public removeUser(email: string) {
    return this.http.delete(this.url(`/users/${email}`));
  }
}

export type OrganizationMember = {
  user: User;
  role: UserRole;
};

export type User = {
  id: number;
  firstName: string;
  lastName: string;
  isActive: boolean;
};
